import { render, staticRenderFns } from "./SelectedTab.vue?vue&type=template&id=73882600&scoped=true&"
import script from "./SelectedTab.vue?vue&type=script&lang=js&"
export * from "./SelectedTab.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTab.vue?vue&type=style&index=0&id=73882600&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73882600",
  null
  
)

export default component.exports